import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { CustomizationTabs, SmsSettingsForm } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useCurrentProject } from '../../../contexts/settings';
import { useProductAgreement } from '../../../hooks';

type RouteParams = { projectId: string };

const SMSCustomization = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { merchantId } = useConfig();
  const { fetchingAgreement, isAgreementSigned } = useProductAgreement(merchantId);
  const { currentProjectFetching, error } = useCurrentProject(projectId);

  if (currentProjectFetching || fetchingAgreement) {
    return (
      <CustomizationTabs>
        <Preloader />
      </CustomizationTabs>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="sms-customization_open" />;
  }

  return (
    <CustomizationTabs>
      <SmsSettingsForm projectId={projectId} isAgreementSigned={isAgreementSigned} />
    </CustomizationTabs>
  );
};

export default withRouter(SMSCustomization);
